





























import { Vue, Component, Emit } from 'vue-property-decorator';
import { namespace, State, Action } from 'vuex-class';
import { MAX_VOTE_NUM, STOR_NAME } from '../api';
const Modules = namespace(STOR_NAME);

const windowHeight = window.innerHeight;

Vue.directive('fixedInput', function temp(el, binding) {
  el.addEventListener('blur', function temp() {
    const windowFocusHeight = window.innerHeight;
    // if (windowHeight === windowFocusHeight) {
    //   return;
    // }
    let currentPosition;
    const speed = 1; // 页面滚动距离

    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // 如果是IOS设备
    if (isiOS) {
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, document.documentElement.scrollTop - 100); // 页面向上滚动
      currentPosition += speed; // speed变量
      window.scrollTo(0, document.documentElement.scrollTop - 100); // 页面向下滚动
    }
  });
});
@Component
export default class Popup extends Vue {
  @Modules.State('balanceC') balanceC!: any;
  likeCount: number | string = '';
  popupShowVal: boolean = false;
  get placeholder() {
    return `请输入点赞数（最大值${MAX_VOTE_NUM}）`;
  }
  handleInput(e: any) {
    e.target.value = e.target.value.replace(/^(0)/g, '');
    e.target.value = e.target.value.replace(/\D/g, '');
  }
  testInput(e: any) {
    const key = e.data || '';
    if (key === '.') {
      e.preventDefault();
    }
  }
  @Emit()
  handleClickCancel() {
    this.$emit('handleClickCancel', false);
  }
  @Emit()
  handleClickConfirm() {
    const value = Number(this.likeCount);
    this.$emit('handleClickConfirm', value);
  }
}
